<template>
<!--  <v-card-->
<!--      flat-->
<!--      rounded="0"-->
<!--      class="mx-auto mt-4"-->
<!--      max-width="1200"-->
<!--      mim-width="350"-->
<!--      color="grey-lighten-4"-->
<!--  >-->
<!--    <v-card-text class="mt-4 text-body-1 text-center">잘못된 페이지 경로 입니다.</v-card-text>-->
<!--    <v-card-text class="mb-3 pt-0 text-center">-->
<!--      <v-btn color="primary" to="/" variant="tonal">홈으로 이동</v-btn>-->
<!--    </v-card-text>-->
<!--  </v-card>-->
</template>

<script>

import {util} from "@/api";

export default {
  name: "NotFound",
  created() {
    this.writeLog()
  },
  methods: {
    writeLog() {
      console.log('url', this.$route.fullPath)
      util.writeLog(this.$route.fullPath)
          .then(() => {
            this.$router.push('/')
          })
          .catch(() => {
            this.$router.push('/')
          })
    }
  }
}
</script>